import {
    SPELLING,
    SPELLING_SPA,
    VOCAB,
    VOCAB_SPA,
    DECODING_ONLINE,
    RAN,
    MAZE,
    CLPL,
} from '../../constants/measure';
import { VOCAB_CAPTIONS, VOCAB_SPA_CAPTIONS } from './vocabCaptions';
import RAN_CAPTIONS from './ranCaptions';
import { SPELLING_CAPTIONS, SPELLING_SPA_CAPTIONS } from './spellingCaptions';
import WR_CAPTIONS from './wrCaptions';
import MAZE_CAPTIONS from './mazeCaptions';
import CLPL_CAPTIONS from './clplCaptions';

const ASSESSMENT_CAPTIONS = {
    [SPELLING.FULL_NAME]: SPELLING_CAPTIONS,
    [SPELLING_SPA.FULL_NAME]: SPELLING_SPA_CAPTIONS,
    [VOCAB.FULL_NAME]: VOCAB_CAPTIONS,
    [VOCAB_SPA.FULL_NAME]: VOCAB_SPA_CAPTIONS,
    [DECODING_ONLINE.FULL_NAME]: WR_CAPTIONS,
    [RAN.FULL_NAME]: RAN_CAPTIONS,
    [MAZE.NAME]: MAZE_CAPTIONS,
    [CLPL.NAME]: CLPL_CAPTIONS,
};

export default ASSESSMENT_CAPTIONS;
